<template>
  <p
    v-if="error"
    class="input-error"
  >
    {{ error }}
  </p>
</template>



<script>
  export default {
    name: 'InputError',

    props: {
      error: {
        type: String,
        default: null
      }
    }
  };
</script>
